export default "__VITE_ASSET__gSXm$MQM__"